class AnnouncementsBar extends HTMLElement {
  constructor() {
    super();

    this.intervalId;
    this.parentSelector = this.querySelector('.tic-Ticker_Item');
    this.exampleTickerItem = this.querySelector('.tic-Ticker_ItemContent');
    this.animationDirection = this.getAttribute('data-animation-direction');
    this.marqueePosition = 0;
    this.halfPoint = this.exampleTickerItem.clientHeight / 2;
    this.isRunning = false;

    this.updateCssVarForHeight = this.updateCssVarForHeight.bind(this);
  }

  connectedCallback() {    
    // Set CSS variable for announcement bar height on mount and when resized/changed
    this.updateCssVarForHeight();
    const resizeObserver = new ResizeObserver(() => this.updateCssVarForHeight());
    resizeObserver.observe(this);
    // Fallback: also adjust on window resize (iOS Safari quirks)
    window.addEventListener('resize', this.updateCssVarForHeight, { passive: true });

    if (this.getAttribute('data-enable-animation') == 'true') {
      const animationDirection = this.animationDirection;

      if (animationDirection == 'horizontal') {
        if (window.matchMedia('(max-width: 1024px)').matches) {
          this.startMarqueeAnimation(this.getAttribute('data-mobile-animation-speed'), animationDirection);

          this.addEventListener('mouseout', () => {
            if (!this.isRunning) {
              this.startMarqueeAnimation(this.getAttribute('data-mobile-animation-speed'), animationDirection);
            }
          });
        } else {
          this.startMarqueeAnimation(this.getAttribute('data-desktop-animation-speed'), animationDirection);

          this.addEventListener('mouseout', () => {
            if (!this.isRunning) {
              this.startMarqueeAnimation(this.getAttribute('data-desktop-animation-speed'), animationDirection);
            }
          });
        }
      } else {
        if (window.matchMedia('(max-width: 1024px)').matches) {
          this.startMarqueeAnimation(this.getAttribute('data-mobile-animation-speed-vertical'), animationDirection);

          this.addEventListener('mouseout', () => {
            if (!this.isRunning) {
              this.startMarqueeAnimation(this.getAttribute('data-mobile-animation-speed-vertical'), animationDirection);
            }
          });
        } else {
          this.startMarqueeAnimation(this.getAttribute('data-desktop-animation-speed-vertical'), animationDirection);

          this.addEventListener('mouseout', () => {
            if (!this.isRunning) {
              this.startMarqueeAnimation(this.getAttribute('data-desktop-animation-speed-vertical'), animationDirection);
            }
          });
        }
      }
    }

    this.addEventListener('mouseover', () => {
      if (this.isRunning) {
        this.stopMarqueeAnimation();
      }
    });

    if(this.querySelector('[data-klaviyo-trigger]')) {
      this.querySelector('[data-klaviyo-trigger]').addEventListener('click', this.openForm.bind(this));
    }
  }

  startMarqueeAnimation(speed, animationDirection) {
    this.isRunning = true;
    this.marqueeAnimation(speed, animationDirection);
  }

  stopMarqueeAnimation() {
    this.isRunning = false;
    clearInterval(this.intervalId);
  }

  marqueeAnimation(speed, animationDirection) {
    if (this.isRunning) {
      this.intervalId = setInterval(() => {
        if (animationDirection == 'horizontal') {
          this.parentSelector.style.transform = `translateX(-${parseInt(this.marqueePosition)}px)`;
          this.parentSelector.setAttribute('data-marquee-position', parseInt(this.marqueePosition));
  
          if (this.marqueePosition > this.parentSelector.clientWidth + 250) {
            this.marqueePosition = 0;
          }
  
          this.marqueePosition = this.marqueePosition + speed / 10;
        } else {
          this.parentSelector.style.transform = `translateY(-${parseInt(this.marqueePosition)}px)`;
          this.parentSelector.setAttribute('data-marquee-position', parseInt(this.marqueePosition));

          if (this.marqueePosition >= this.halfPoint) {
            this.stopMarqueeAnimation();
            this.halfPoint += this.exampleTickerItem.clientHeight;
            setTimeout(() => {
              if (!this.isRunning) {
                this.startMarqueeAnimation(this.getAttribute('data-desktop-animation-speed-vertical'), animationDirection);
              }
            }, 2000);
          } else {
            if (this.marqueePosition > this.parentSelector.clientHeight + 15) {
              this.marqueePosition = 0;
              this.halfPoint = this.exampleTickerItem.clientHeight / 2;
            }
    
            this.marqueePosition = this.marqueePosition + speed / 80;
          }
        }
      }, 0);
    }
  }

  openForm() {
    const formId = this.querySelector('[data-klaviyo-trigger]').dataset.klaviyoTrigger;
    
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }

  updateCssVarForHeight() {
    try {
      const barHeight = this.offsetHeight || 0;
      // Apply on documentElement so all components can read it
      document.documentElement.style.setProperty('--announcement-bar-height', `${barHeight}px`);
    } catch (e) {
      // no-op
    }
  }
}

if (!customElements.get('announcement-bar', AnnouncementsBar)) {
  customElements.define('announcement-bar', AnnouncementsBar);
}
